const initialState = {
  pic: null,
	partnerName: null,
  partnerSex: null,
  partnerAttestation: null,
  partnerStop: null,
  memo: '',
  isFavorite: null,
  favoriteLimit: false,
  isNondisplay: null,
  isRefusal: null,
  isFootprint: null,
  footprintMyDelRemain: 0,
  menu: [],
};

export default function reducer(state = initialState, action) {

	if (action.type === 'PARTNER_OPERATION_OPEN') {
		let newState = Object.assign({}, state);
    newState.pic = action.payload.pic;
    newState.partnerName = action.payload.partnerName;
    newState.partnerSex = action.payload.partnerSex;
    newState.partnerAttestation = action.payload.partnerAttestation;
    newState.partnerStop = action.payload.partnerStop;
    newState.memo = action.payload.memo;
    newState.isFavorite = action.payload.isFavorite;
    newState.favoriteLimit = action.payload.favoriteLimit;
    newState.isNondisplay = action.payload.isNondisplay;
    newState.isRefusal = action.payload.isRefusal;
    newState.isFootprint = action.payload.isFootprint;
    newState.footprintMyDelRemain = action.payload.footprintMyDelRemain;
    newState.menu = action.payload.menu;
		return newState;
	}
  else if (action.type === 'PARTNER_OPERATION_CLOSE') {
		let newState = Object.assign({}, state);
    newState.pic = null;
		return newState;
	}
	else {
		return state;
	}
}
